module.exports = __webpack_public_path__ + "assets_1713491368921/img/guide_android.4b8e8721.png";